import { CreateNewList } from '../CallsToAction/CreateNewList';

export function Onboarding() {
  return (
    <>
      <CreateNewList />
    </>
  );
}
